
define('ldsh!modules/form_editor/templates/preview_custom_linlogin_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<script async custom-element="amp-access" src="https://cdn.ampproject.org/v0/amp-access-0.1.js"></script>\n<script id="amp-access" type="application/json">\n  {\n    "authorization": "https://ampbyexample.com/oauth/status?_=RANDOM",\n    "noPingback": "true",\n    "login": {\n      "linkedin-sign-in": "https://ampbyexample.com/oauth/login/linkedin"\n    },\n    "authorizationFallbackResponse": {\n      "error": true,\n      "loggedIn": false\n    }\n  }\n</script>\n\n<div amp-access="NOT loggedIn" amp-access-hide>\n  <div id="' +
((__t = ( idName )) == null ? '' : __t) +
'" class="ed-item-socialbox ed-item-socialbox-h ' +
((__t = ( position )) == null ? '' : __t) +
'">\n    <script type="in/Login"\n            class="ed-social-block ed-linkedIn-login size-' +
((__t = ( size )) == null ? '' : __t) +
' lin_img"></script>\n  </div>\n</div>\n';

}
return __p
};});

